/** Normalize axios errors so callers can use error.data / error.message safely. */
export function wrapAxiosError(error) {
  if (error == null) {
    return new Error('Unknown error');
  }
  if (error instanceof Error && error.response == null && error.request == null) {
    return error;
  }
  const res = error.response;
  if (res) {
    const err = new Error(error.message || `Request failed with status ${res.status}`);
    err.status = res.status;
    err.data = res.data;
    return err;
  }
  if (typeof error === 'object' && error.message) {
    return error instanceof Error ? error : new Error(error.message);
  }
  return new Error(String(error));
}
